import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { SelectInputModel } from '@libs/form/models';
import { MatConstantsModule } from '@libs/shared/ui';
import { ErrorDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { FormInputDescriptionComponent } from '../../description';
import { InputProviderFactory } from '../ng-input-provider';

@Component({
  selector: 'ui-form-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  providers: [
    ...InputProviderFactory.getProviders(SelectComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatConstantsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    ReactiveFormsModule,
    ErrorDirective,
    FormInputDescriptionComponent,
  ],
})
export class SelectComponent extends InputBaseComponent {
  @Input()
  public data!: SelectInputModel;

  @ViewChild(MatSelect, { static: true })
  public valueAccessor!: ControlValueAccessor;
}
